import React from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";

const Invoices = () => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 order-general-settings chart-of-accounts">
          <div className="container px-0">
            <div className="row orderManagementSetting d-flex">
              <div className="col-md-12">
                <div className="shadowclass d-flex flex-wrap align-content-start">
                  <h4 className="event-alert w-100">Coming Soon...</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

export default Invoices;
